import { Typography, TypographyProps } from '@material-ui/core';

const Paragraph = (props: TypographyProps) => <Typography align='justify' paragraph {...props} />;

export default Paragraph;
